import React from 'react'

import cn from 'classnames'
import s from './TimelineList.scss'
import sLay from 'styles/modules/layout.scss'
import { Link } from 'react-router'

export default props => (
  <div
    className={cn(
      s.listItem,
      { [s.active]: props.complete },
      sLay['layout-row'],
      sLay['layout-align-start-center']
    )}
  >
    <div className={cn(s.marker)} />
    {props.to ? (
      <Link className={s.text} to={props.to}>
        {props.children}
      </Link>
    ) : (
      <a className={cn(s.text, { [s.disabled]: !props.hasClick })} onClick={props.onClick}>
        {props.children}
      </a>
    )}
  </div>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/TimelineList/TimelineListItem.jsx